import React from 'react'
import { Blanket, Bottles, BusImg, Charger } from '../../../../assests/ExportImageIcon'
import './busSeatSelection.css'
import './busBoarding.css'
import './busPhotos.css'

// Static placeholder — no bus API exists yet, so amenities/photos below are
// hardcoded to match the reference design (no state, no click behaviour).
// Only one real bus-interior photo exists in assets, so it's repeated to
// match the reference's photo strip. Once a bus API exists, this can be
// wired up for real. Content only (no tab bar) — rendered by
// SeatBookingPanel.jsx alongside the PHOTOS & AMENITIES tab.
const AMENITIES = [
    { icon: Bottles, label: 'Water Bottle' },
    { icon: Charger, label: 'Charing Point' },
    { icon: Blanket, label: 'Blanket' },
]

const PHOTOS = [BusImg, BusImg, BusImg, BusImg]

const BusPhotos = () => {
    return (
        <div className='seatSelectPanel'>
            <div className='seatSelectPanel__title'>Photos & Amenities</div>

            <div className='busPhotosPanel__body'>
                <div className='boardingCol__title'>Amenities</div>
                <div className='busAmenities'>
                    {AMENITIES.map((item) => (
                        <div className='busAmenityItem' key={item.label}>
                            <span className='busAmenityItem__icon'>
                                <img src={item.icon} alt="" />
                            </span>
                            <span className='busAmenityItem__label'>{item.label}</span>
                        </div>
                    ))}
                </div>

                <div className='boardingCol__title'>Photos</div>
                <div className='busPhotosRow'>
                    {PHOTOS.map((photo, index) => (
                        <img src={photo} alt="Bus interior" key={index} />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default BusPhotos
